import React from 'react';
import { Grow, Stack } from '@mui/material';
import AssignCategory from './AssignCategory';
import AssignAllProduct from './AssignAllProduct';
import AssignSelectedProduct from './AssignSelectedProduct';

export default function AssignProduct({ id, shop, type, products_shop, refetch, isActive, assignment_type:  assignmentType }) {
  return (
    <Grow in={isActive}>
      <Stack direction="row" width="100%" columnGap={1}>
        <AssignSelectedProduct
          id={id}
          shop={shop}
          refetch={refetch}
          products={products_shop}
          active={assignmentType === 'SELECTED_PRODUCT'}
        />
        <AssignCategory id={id} refetch={refetch} active={assignmentType === 'CATEGORY'} shop={shop} />
        <AssignAllProduct id={id} refetch={refetch} active={assignmentType === 'ALL_PRODUCT'} />
      </Stack>
    </Grow>
  );
}
